module.exports = __webpack_public_path__ + "img/overview.ddbe5c43.webp";